import { CSS } from "@dnd-kit/utilities";
import Sections from "./Sections";
import { CommonBuilderComponent } from "../../Builder/Common/CommonBuilderComponent";

import { useSortable } from "@dnd-kit/sortable";
const PageSections = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: "none",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      data-testid="card-item"
      className="w-full"
    >
      <CommonBuilderComponent>
        <Sections
          {...props}
          dragHandleProps={{ ...attributes, ...listeners }}
        />
      </CommonBuilderComponent>
    </div>
  );
};

export default PageSections;
